import { MainContainer } from "components/shared";
import { SettingLayout } from "layouts/SettingLayout";
import { InnerOptions } from "../InnerOptions";
import { Box } from "components/ui/Box";
import { CreateForm } from "./CreateForm";

export const HubCreateVehicle: React.FC = () => {
  const { options } = InnerOptions();
  return (
    <MainContainer>
      <SettingLayout options={options}>
        <Box>
          <CreateForm />
        </Box>
      </SettingLayout>
    </MainContainer>
  );
};
